import script from "./ProductCharateristicsIndex.vue?vue&type=script&lang=js"
export * from "./ProductCharateristicsIndex.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__